import { useQuery } from "react-query";

import { Appointment } from "api/types/appointments";
import { STALE_TIME_5_MINUTES, GET_APPOINTMENT_INFO } from "@constants/reactQueryKeys";
import { getAppointmentInfo } from "api/appointments";

/**
 * Hook to fetch appointment info by id from the API `/v3/appointments/[id]` endpoint.
 *
 * @param {string} id - The appointment id
 * @returns {{ appointment: Appointment | null }} A object containing the appointment info, loading state, and refetch function
 */
const useGetAppointmentInfo = (id: string) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_APPOINTMENT_INFO, id],
    () => getAppointmentInfo(id),
    {
      enabled: Boolean(id),
      staleTime: STALE_TIME_5_MINUTES,
    }
  );

  return {
    appointment: (data?.data as Appointment) || null,
    isAppointmentLoading: isLoading,
    refetchAppointment: refetch,
    ...rest,
  };
};

export default useGetAppointmentInfo;
